var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7295 0.556264C12.0225 0.849276 12.187 1.24663 12.187 1.66095C12.187 2.07527 12.0225 2.47263 11.7295 2.76564L3.99517 10.5L11.7295 18.2344C12.0142 18.5291 12.1717 18.9238 12.1681 19.3335C12.1645 19.7431 12.0002 20.135 11.7105 20.4247C11.4208 20.7144 11.0289 20.8788 10.6192 20.8823C10.2096 20.8859 9.81486 20.7284 9.52017 20.4438L0.681112 11.6047C0.388188 11.3117 0.223633 10.9143 0.223633 10.5C0.223633 10.0857 0.388188 9.68834 0.681112 9.39533L9.52017 0.556264C9.81319 0.263341 10.2105 0.0987854 10.6249 0.0987854C11.0392 0.0987854 11.4365 0.263341 11.7295 0.556264Z",
    fill: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.76e1b5a80c42ef3b6d05a248dd4dff29.svg";
export { ForwardRef as ReactComponent };